// Product type detection and configuration

export const PRODUCT_TYPES = {
  MONAMODI: 'MONAMODI',
  OTHER: 'OTHER'
};

// Monamodi plan names (plan 1 to plan 7)
const MONAMODI_PLANS = [
  'plan 1',
  'plan 2',
  'plan 3',
  'plan 4',
  'plan 5',
  'plan 6',
  'plan 7'
];

/**
 * Determines the product type based on policy data
 * @param {Object} policy - The policy object
 * @returns {string} - The product type (MONAMODI or OTHER)
 */
export function getProductType(policy) {
  if (!policy) {
    return null;
  }

  // Check if policy has a product_name field
  const productName = policy.product_name;

  if (!productName) {
    return PRODUCT_TYPES.OTHER;
  }

  // Normalize the product name for comparison
  const normalizedProductName = productName.toLowerCase().trim();

  // Check if it's a Monamodi plan (plan 1 to plan 7)
  if (MONAMODI_PLANS.includes(normalizedProductName)) {
    return PRODUCT_TYPES.MONAMODI;
  }

  // Default to OTHER for any unrecognized product
  return PRODUCT_TYPES.OTHER;
}

/**
 * Checks if a product type is currently supported for amendments
 * @param {string} productType - The product type
 * @returns {boolean} - Whether amendments are supported
 */
export function isProductSupported(productType) {
  return productType === PRODUCT_TYPES.MONAMODI;
}
